(function () {
  if (window.aeUpsellMeasurementLoaded) return;
  window.aeUpsellMeasurementLoaded = true;

  var blockSelector = '.shopify-app-block[id*="__aov_ai_bundle_offer_inline_"]';
  var visibleOfferSelector = '.Avada-OfferItem.-fbt:not(.ae-fbt-offer-hidden)';
  var hasTrackedImpression = false;
  var pollCount = 0;
  var offerCache = {};

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
  }

  function productHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : window.location.pathname;
  }

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function visibleOfferItems(block) {
    return toArray(block.querySelectorAll(visibleOfferSelector));
  }

  function productTitles(block) {
    return visibleOfferItems(block)
      .map(function (row) {
        return cleanText(row.querySelector('.Avada-OfferItem__Content-ProductTitle') && row.querySelector('.Avada-OfferItem__Content-ProductTitle').textContent);
      })
      .filter(function (text) { return text.length > 0; });
  }

  function selectedTitles(block) {
    return visibleOfferItems(block)
      .filter(function (row) { return row.classList.contains('isSelected'); })
      .map(function (row) {
        return cleanText(row.querySelector('.Avada-OfferItem__Content-ProductTitle') && row.querySelector('.Avada-OfferItem__Content-ProductTitle').textContent);
      })
      .filter(function (text) { return text.length > 0; });
  }

  function pushUpsellEvent(eventName, detail) {
    var payload = detail || {};
    payload.event = eventName;
    payload.product_handle = productHandle();
    payload.page_path = window.location.pathname;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    document.documentElement.setAttribute('data-ae-upsell-last-event', eventName);
    if (typeof payload.selected_count !== 'undefined') {
      document.documentElement.setAttribute('data-ae-upsell-selected-count', String(payload.selected_count));
    }
    if (typeof payload.offer_count !== 'undefined') {
      document.documentElement.setAttribute('data-ae-upsell-offer-count', String(payload.offer_count));
    }
  }

  function readContext() {
    var script = document.getElementById('ae-fbt-context');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function isMobileViewport() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function normaliseWords(value) {
    return cleanText(String(value || ''))
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, ' ')
      .split(/[\s-]+/)
      .filter(function (word) {
        return word.length > 2 && ['the', 'and', 'for', 'with', 'aquarium', 'plant', 'plants', 'live'].indexOf(word) === -1;
      });
  }

  function uniqueWords(words) {
    return words.filter(function (word, index) {
      return words.indexOf(word) === index;
    });
  }

  function containsAny(haystack, needles) {
    return needles.some(function (needle) {
      return haystack.indexOf(needle) !== -1;
    });
  }

  function detectFormat(text, tags, type) {
    var haystack = cleanText([text, type].concat(tags || []).join(' ')).toLowerCase();

    if (containsAny(haystack, ['aquarium soil', 'plant growth substrate', 'substrate', 'nutri base', 'nutri-base', 'aqua soil'])) return 'substrate';
    if (haystack.indexOf('1-2-grow') !== -1 || haystack.indexOf('tissue culture') !== -1) return 'tissue-culture';
    if (containsAny(haystack, ['mixed box', 'box of aquarium plants', 'collection', 'bundle', 'scaped for you'])) return 'bundle';
    if (containsAny(haystack, ['frogbit', 'limnobium', 'salvinia', 'red root floater', 'floating plant', 'floating plants'])) return 'floating';
    if (haystack.indexOf('on wood') !== -1 || haystack.indexOf('driftwood') !== -1) return 'mounted';
    if (haystack.indexOf('moss') !== -1) return 'moss';
    if (haystack.indexOf('rock') !== -1 || haystack.indexOf('stone') !== -1) return 'rock';
    if (haystack.indexOf('wood') !== -1 || haystack.indexOf('bogwood') !== -1 || haystack.indexOf('driftwood') !== -1) return 'wood';
    if (haystack.indexOf('fertiliser') !== -1 || haystack.indexOf('fertilizer') !== -1 || haystack.indexOf('co2') !== -1) return 'treatment';
    if (haystack.indexOf('tool') !== -1 || haystack.indexOf('scissors') !== -1 || haystack.indexOf('tweezers') !== -1) return 'accessory';
    if (haystack.indexOf('pot') !== -1 || haystack.indexOf('potted') !== -1) return 'potted';

    return 'general';
  }

  function detectFamily(text, tags, type) {
    var haystack = cleanText([text, type].concat(tags || []).join(' ')).toLowerCase();

    if (containsAny(haystack, ['aquarium soil', 'plant growth substrate', 'substrate', 'nutri base', 'nutri-base', 'aqua soil'])) return 'substrate';
    if (containsAny(haystack, ['mixed box', 'box of aquarium plants', 'collection', 'bundle', 'scaped for you'])) return 'bundle';
    if (haystack.indexOf('wood') !== -1 || haystack.indexOf('bogwood') !== -1 || haystack.indexOf('driftwood') !== -1) return 'hardscape-wood';
    if (haystack.indexOf('rock') !== -1 || haystack.indexOf('stone') !== -1) return 'hardscape-rock';
    if (containsAny(haystack, ['frogbit', 'limnobium', 'salvinia', 'red root floater', 'floating plant', 'floating plants'])) return 'floating-plant';
    if (haystack.indexOf('moss') !== -1) return 'moss';
    if (haystack.indexOf('fertiliser') !== -1 || haystack.indexOf('fertilizer') !== -1 || haystack.indexOf('co2') !== -1) return 'treatment';
    if (haystack.indexOf('tool') !== -1 || haystack.indexOf('scissors') !== -1 || haystack.indexOf('tweezers') !== -1) return 'accessory';

    return 'plant';
  }

  function detectIntent(format, family) {
    if (family === 'substrate') return 'aquascape-foundation';
    if (family === 'hardscape-wood' || family === 'hardscape-rock') return 'hardscape-layout';
    if (family === 'bundle') return 'curated-selection';
    if (family === 'treatment') return 'plant-care';
    if (family === 'accessory') return 'maintenance-tool';
    if (family === 'floating-plant') return 'surface-cover';
    if (family === 'moss') return 'detail-texture';
    if (format === 'mounted') return 'mounted-feature';
    return 'planting';
  }

  function overlapCount(left, right) {
    var seen = {};

    left.forEach(function (word) {
      seen[word] = true;
    });

    return right.filter(function (word, index) {
      return seen[word] && right.indexOf(word) === index;
    }).length;
  }

  function buildProductShape(source) {
    var tags = Array.isArray(source.tags) ? source.tags : [];
    var titleWords = uniqueWords(normaliseWords(source.title));
    var tagWords = uniqueWords(normaliseWords(tags.join(' ')));

    return {
      handle: source.handle || '',
      title: cleanText(source.title),
      vendor: cleanText(source.vendor),
      type: cleanText(source.type),
      tags: tags,
      titleWords: titleWords,
      tagWords: tagWords,
      format: detectFormat(source.title, tags, source.type),
      family: detectFamily(source.title, tags, source.type),
      intent: detectIntent(
        detectFormat(source.title, tags, source.type),
        detectFamily(source.title, tags, source.type)
      )
    };
  }

  function applyPageContext(currentProduct) {
    if (!currentProduct) return;
    document.documentElement.setAttribute('data-ae-product-format', currentProduct.format || 'general');
    document.documentElement.setAttribute('data-ae-product-family', currentProduct.family || 'general');
    document.documentElement.setAttribute('data-ae-product-intent', currentProduct.intent || 'general');
  }

  function toProductJsonUrl(url) {
    if (!url) return '';

    try {
      var parsed = new URL(url, window.location.origin);
      var pathnameMatch = parsed.pathname.match(/\/products\/([^/?#]+)/);
      if (!pathnameMatch) return '';
      return parsed.origin + '/products/' + pathnameMatch[1] + '.js';
    } catch (error) {
      return '';
    }
  }

  function fetchOfferProduct(url) {
    var jsonUrl = toProductJsonUrl(url);
    if (!jsonUrl) return Promise.resolve(null);
    if (offerCache[jsonUrl]) return offerCache[jsonUrl];

    offerCache[jsonUrl] = window.fetch(jsonUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .catch(function () {
        return null;
      });

    return offerCache[jsonUrl];
  }

  function scoreOffer(currentProduct, offerProduct) {
    var score = 0;
    var titleOverlap = overlapCount(currentProduct.titleWords, offerProduct.titleWords);
    var tagOverlap = overlapCount(currentProduct.tagWords, offerProduct.tagWords);
    var isSameVendor = currentProduct.vendor && offerProduct.vendor && currentProduct.vendor === offerProduct.vendor;
    var likelySubstitute =
      currentProduct.handle !== offerProduct.handle &&
      currentProduct.family === offerProduct.family &&
      currentProduct.format === offerProduct.format &&
      isSameVendor &&
      titleOverlap >= 2;

    if (currentProduct.family === offerProduct.family) score += 45;
    if (currentProduct.type && offerProduct.type && currentProduct.type === offerProduct.type) score += 40;
    if (isSameVendor) score += 12;
    if (currentProduct.format === offerProduct.format) score += 26;
    if (currentProduct.intent === offerProduct.intent) score += 22;

    if (currentProduct.family === 'plant' && offerProduct.family !== 'plant') score -= 40;
    if (currentProduct.family !== 'plant' && offerProduct.family === 'plant') score -= 24;
    if (currentProduct.family === 'substrate' && ['plant', 'floating-plant', 'moss', 'bundle'].indexOf(offerProduct.family) !== -1) score -= 45;
    if (currentProduct.family === 'bundle' && offerProduct.family === 'bundle') score -= 18;
    if (currentProduct.family === 'bundle' && offerProduct.family === 'plant') score -= 8;

    if (currentProduct.format === 'potted' && offerProduct.format === 'tissue-culture') score -= 16;
    if (currentProduct.format === 'tissue-culture' && offerProduct.format === 'potted') score -= 10;
    if (currentProduct.format === 'bundle' && offerProduct.format !== 'bundle') score -= 10;
    if (currentProduct.format === 'substrate' && offerProduct.format === 'bundle') score -= 18;
    if (currentProduct.format === 'floating' && offerProduct.format === 'bundle') score -= 12;
    if (likelySubstitute) score -= 30;

    score += Math.min(24, tagOverlap * 8);
    score += Math.min(18, titleOverlap * 6);

    return score;
  }

  function rowMeta(row) {
    var titleNode = row.querySelector('.Avada-OfferItem__Content-ProductTitle');
    var link = titleNode && titleNode.querySelector('a[href*="/products/"]');

    return {
      row: row,
      title: cleanText(titleNode && titleNode.textContent),
      url: link ? link.getAttribute('href') : ''
    };
  }

  function visibleSelectedCount(block) {
    return visibleOfferItems(block).filter(function (row) {
      return row.classList.contains('isSelected');
    }).length;
  }

  function filterSignature(block) {
    return toArray(block && block.querySelectorAll('.Avada-OfferItem.-fbt'))
      .map(function (row) {
        var title = cleanText(row.querySelector('.Avada-OfferItem__Content-ProductTitle') && row.querySelector('.Avada-OfferItem__Content-ProductTitle').textContent);
        var isHidden = row.classList.contains('ae-fbt-offer-hidden') ? 'hidden' : 'shown';
        var isSelected = row.classList.contains('isSelected') ? 'selected' : 'plain';
        return [title, isHidden, isSelected].join('::');
      })
      .join('||');
  }

  function refreshDiagnosticAttributes(block) {
    document.documentElement.setAttribute('data-ae-upsell-selected-count', String(visibleSelectedCount(block)));
    document.documentElement.setAttribute('data-ae-upsell-offer-count', String(visibleOfferItems(block).length));
  }

  function setRowVisibility(row, shouldShow) {
    if (!row) return;

    if (shouldShow) {
      row.classList.remove('ae-fbt-offer-hidden');
      row.removeAttribute('data-ae-fbt-hidden');
      row.style.removeProperty('display');
      row.style.removeProperty('visibility');
      row.style.removeProperty('pointer-events');
      row.style.removeProperty('height');
      row.style.removeProperty('overflow');
      row.style.removeProperty('padding-top');
      row.style.removeProperty('padding-bottom');
      row.style.removeProperty('margin-top');
      row.style.removeProperty('margin-bottom');
      row.style.removeProperty('border-top');
      row.style.removeProperty('border-bottom');
      return;
    }

    row.classList.add('ae-fbt-offer-hidden');
    row.setAttribute('data-ae-fbt-hidden', 'true');
    row.style.setProperty('display', 'none', 'important');
    row.style.setProperty('visibility', 'hidden', 'important');
    row.style.setProperty('pointer-events', 'none', 'important');
    row.style.setProperty('height', '0', 'important');
    row.style.setProperty('overflow', 'hidden', 'important');
    row.style.setProperty('padding-top', '0', 'important');
    row.style.setProperty('padding-bottom', '0', 'important');
    row.style.setProperty('margin-top', '0', 'important');
    row.style.setProperty('margin-bottom', '0', 'important');
    row.style.setProperty('border-top', '0', 'important');
    row.style.setProperty('border-bottom', '0', 'important');
  }

  function sortByScoreDescending(left, right) {
    return right.score - left.score;
  }

  async function applyCommercialFilter(block) {
    if (!block || !isMobileViewport()) return;
    if (block.getAttribute('data-ae-fbt-filtered') === 'true') return;

    var currentContext = readContext();
    var productList = block.querySelector('.Avada-Fbt__ProductList.amazon');
    var rows = visibleOfferItems(block);
    if (!currentContext || !productList || rows.length <= 4) {
      if (currentContext) {
        applyPageContext(buildProductShape(currentContext));
      }
      block.__aeFbtLastSignature = filterSignature(block);
      block.setAttribute('data-ae-fbt-filtered', 'true');
      refreshDiagnosticAttributes(block);
      return;
    }

    block.setAttribute('data-ae-fbt-filtered', 'pending');

    var currentRow = rows[0];
    var currentProduct = buildProductShape(currentContext);
    applyPageContext(currentProduct);
    var candidates = rows.slice(1);

    var scoredOffers = await Promise.all(candidates.map(async function (row) {
      var meta = rowMeta(row);
      var fetched = meta.url ? await fetchOfferProduct(meta.url) : null;
      var offerProduct = buildProductShape({
        handle: fetched && fetched.handle ? fetched.handle : meta.url,
        title: fetched && fetched.title ? fetched.title : meta.title,
        vendor: fetched && fetched.vendor ? fetched.vendor : '',
        type: fetched && fetched.type ? fetched.type : '',
        tags: fetched && Array.isArray(fetched.tags) ? fetched.tags : []
      });

      return {
        row: row,
        score: scoreOffer(currentProduct, offerProduct)
      };
    }));

    scoredOffers.sort(sortByScoreDescending);

    scoredOffers.forEach(function (offer) {
      setRowVisibility(offer.row, true);
    });

    scoredOffers.forEach(function (offer) {
      productList.appendChild(offer.row);
    });

    if (currentRow) {
      productList.insertBefore(currentRow, productList.firstChild);
    }

    block.__aeFbtLastSignature = filterSignature(block);
    block.setAttribute('data-ae-fbt-filtered', 'true');
    refreshDiagnosticAttributes(block);
  }

  function scheduleFilterRefresh(block) {
    if (!block || block.__aeFbtRefreshScheduled) return;

    block.__aeFbtRefreshScheduled = true;

    window.setTimeout(function () {
      block.__aeFbtRefreshScheduled = false;

      var nextSignature = filterSignature(block);
      if (!nextSignature || nextSignature === block.__aeFbtLastSignature) {
        refreshDiagnosticAttributes(block);
        return;
      }

      block.removeAttribute('data-ae-fbt-filtered');
      applyCommercialFilter(block).catch(function () {
        refreshDiagnosticAttributes(block);
      });
    }, 220);
  }

  function watchBlock(block) {
    if (!block || block.__aeFbtObserver) return;

    block.__aeFbtLastSignature = filterSignature(block);

    var observer = new MutationObserver(function (mutations) {
      var hasRelevantChange = mutations.some(function (mutation) {
        return mutation.type === 'childList' || mutation.type === 'attributes';
      });

      if (!hasRelevantChange) return;
      scheduleFilterRefresh(block);
    });

    observer.observe(block, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    block.__aeFbtObserver = observer;
  }

  function primeDelayedRefreshes(block) {
    if (!block || block.__aeFbtDelayedRefreshesPrimed) return;

    block.__aeFbtDelayedRefreshesPrimed = true;

    [600, 1400, 2600, 4200].forEach(function (delay) {
      window.setTimeout(function () {
        if (!document.body.contains(block)) return;
        block.removeAttribute('data-ae-fbt-filtered');
        applyCommercialFilter(block).catch(function () {
          refreshDiagnosticAttributes(block);
        });
      }, delay);
    });
  }

  function bind(block) {
    var offerCount = block ? visibleOfferItems(block).length : 0;
    if (!block || offerCount < 1) return false;
    if (block.getAttribute('data-ae-upsell-bound') === 'true') return true;
    block.setAttribute('data-ae-upsell-bound', 'true');

    if (!hasTrackedImpression) {
      hasTrackedImpression = true;
      pushUpsellEvent('ae_upsell_impression', {
        offer_count: offerCount,
        selected_count: visibleSelectedCount(block),
        products: productTitles(block)
      });
    }

    block.addEventListener('click', function (event) {
      var target = event.target;
      var addButton = target.closest && target.closest('.Avada-Offer__ButtonAddToCart');
      var selectorTarget = target.closest && target.closest('.Avada-Checkbox__Wrapper, .Avada-OfferItem.-fbt');

      if (addButton) {
        pushUpsellEvent('ae_upsell_add_selected_click', {
          selected_count: visibleSelectedCount(block),
          selected_products: selectedTitles(block)
        });
        return;
      }

      if (selectorTarget) {
        window.setTimeout(function () {
          refreshDiagnosticAttributes(block);
          pushUpsellEvent('ae_upsell_selection_change', {
            selected_count: visibleSelectedCount(block),
            selected_products: selectedTitles(block)
          });
        }, 160);
      }
    }, true);

    refreshDiagnosticAttributes(block);
    return true;
  }

  async function prepareBlock() {
    var block = document.querySelector(blockSelector);
    if (!block) return false;
    return bind(block);
  }

  function pollForBlock() {
    pollCount += 1;
    prepareBlock().then(function (ready) {
      if (ready || pollCount > 60) return;
      window.setTimeout(pollForBlock, 250);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pollForBlock);
  } else {
    pollForBlock();
  }
})();
